import { useRef } from 'react';
import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

export default function PointInput(props) {
  const { value, setValue, onBlur } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  // focus 시점의 값 스냅샷 — 실패 롤백/skip-unchanged 판정용 //
  const snapshotRef = useRef(value);

  function handleChange(e) {
    let regex = /[^0-9]/g;				// 숫자가 아닌 문자열을 매칭하는 정규식
    let result = e.target.value.replace(regex, "");	// 원래 문자열에서 숫자가 아닌 모든 문자열을 빈 문자로 변경
    setValue(result === '' ? 0 : parseInt(result));
  }

  // 입력 포커스시 — blur 시 변경 판정용 스냅샷 //
  function handleFocus() {
    snapshotRef.current = value;
  }

  // 입력 포커스 해제시 — 변경 없으면 skip, 변경 있으면 rollback 콜백과 함께 onBlur 호출 //
  function handleBlur() {
    if (value === snapshotRef.current) return;

    const prev = snapshotRef.current;
    snapshotRef.current = value;
    if (onBlur) onBlur(value, () => {
      setValue(prev);
      snapshotRef.current = prev;
    });
  }

  return (
    <TopLevelWrapper>
      <TopWrapper>
        <LeftWrapper>
          <Input
            placeholder={0}
            value={value}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur} />
        </LeftWrapper>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText}>POINT</Text>
      </TopWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  transition: all 0.3s ease-in-out;
`;

const TopWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const Input = styled.input`
  display: flex;
  flex-direction: row;

  align-items: center;

  // width: 69px;
  width: 53px;
  height: 30px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

  padding: 0 8px 0 8px;
  // margin: 0 5px 0 0;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  ::placeholder {
    color: ${props => props.theme.line};
  }
`;

const Text = styled.p`
  font-fmaily: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
`;
